import React, { Component } from "react";
import { connect } from "react-redux";

import styled from "styled-components";
import { withFirebase } from "../Firebase";
import PropTypes from "prop-types";
import { Box, Flex, Heading, Text } from "rebass";
import { Avatar, Divider } from "reakit";
import { schoolSelectors } from "../../store/school";
// import {StyledLink} from "../Base/styles";
import Parents from "../StudentSummary/Parents";
// import {authActions, authSelectors} from "../../store/auth";

const ProfileWrapper = styled.div`
  //min-width: 300px;
`;

const StyledLink = styled.a`
  text-decoration: none;
`;

StyledLink.defaultProps = {
  color: "#969a9b",
};

class ProfileCard extends Component {
  state = {
    parents: [],
  };

  componentDidMount() {
    this.handleFetchParentInfo();
  }

  handleFetchParentInfo = async () => {
    const { firebase, profile } = this.props;
    let parents = profile.parents;
    if (parents.length > 0) {
      try {
        let result = [];
        let parentRef = firebase.parents();
        for (let i in parents) {
          let doc = await parentRef.doc(parents[i]).get();
          result.push({ id: doc.id, ...doc.data() });
        }
        this.setState({ parents: result });
      } catch (err) {}
    }
  };

  render() {
    const { parents } = this.state;
    const { profile, schoolInfo } = this.props;
    let dorm = "";
    if (schoolInfo && schoolInfo.subDormMap) {
      const dormData = schoolInfo.subDormMap[profile.sub_dorm];

      if (dormData) {
        dorm = dormData.name;
      }
    }
    return (
      <ProfileWrapper>
        <Flex flexWrap={"wrap"} p={1} mt={1} px={2}>
          <Box width={1}>
            <Flex>
              <Box>
                <Heading as={"h5"}>
                  {profile.first_name} {profile.last_name}
                </Heading>
              </Box>
              <Box ml={"auto"} />
              <Box>
                <Avatar
                  src={profile.profile_pic}
                  width={"70px"}
                  height={"70px"}
                  backgroundColor={"#707070"}
                />
              </Box>
            </Flex>
          </Box>
          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Flex width={1} py={3}>
            <Box width={1 / 2}>
              <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>
                Email
              </Text>
            </Box>
            <Box ml={"auto"} />
            <Box>
              <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>
                {profile.email}
              </Text>
            </Box>
          </Flex>

          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Flex width={1} py={3}>
            <Box width={1 / 2}>
              <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>
                Mobile
              </Text>
            </Box>
            <Box ml={"auto"} />
            <Box>
              <StyledLink
                href={`tel:${profile.home_phone.split("-").join("")}`}
              >
                <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>
                  {profile.home_phone}
                </Text>
              </StyledLink>
            </Box>
          </Flex>

          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Flex width={1} py={3}>
            <Box width={1 / 2}>
              <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>
                Grade
              </Text>
            </Box>
            <Box ml={"auto"} />
            <Box>
              <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>
                {profile.grade}
              </Text>
            </Box>
          </Flex>
          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Flex width={1} py={3}>
            <Box width={1 / 2}>
              <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>
                Dorm
              </Text>
            </Box>
            <Box ml={"auto"} />
            <Box>
              <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>
                {dorm}
              </Text>
            </Box>
          </Flex>

          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Box width={1} py={3}>
            <Parents parents={parents} profile={profile} />
          </Box>
          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>
        </Flex>
      </ProfileWrapper>
    );
  }
}

ProfileCard.propTypes = {
  profile: PropTypes.object,
  type: PropTypes.string,
  isFaculty: PropTypes.bool,
};

ProfileCard.defaultProps = {
  type: "student",
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
});

export default withFirebase(connect(mapStateToProps)(ProfileCard));
